import React from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import clsx from 'clsx'
import useRadioStyles from './RadioInputStyle'
import PropTypes from 'prop-types'

// Inspired by blueprintjs
function RadioInputStyle(props) {
  const classes = useRadioStyles()

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  )
}

const RadioInput = (props) => {
  return (
    <RadioGroup row value={props.value} onChange={props.onChange} {...props}>
      {props.data.map((row) => (
        <FormControlLabel
          key={row.value}
          value={row.value}
          control={<RadioInputStyle />}
          label={row.label}
        />
      ))}
    </RadioGroup>
  )
}

RadioInput.propTypes = {
  data: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default RadioInput
